"use client";

import { useEffect, useRef, useState } from "react";
import type { SitePhone } from "@/lib/public-contact";

const TEXT = {
  showPhones: "\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u044c\u0020\u0442\u0435\u043b\u0435\u0444\u043e\u043d\u044b",
  dialogTitle: "\u0422\u0435\u043b\u0435\u0444\u043e\u043d\u044b\u0020\u043c\u0430\u0433\u0430\u0437\u0438\u043d\u0430",
  contactTitle: "\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f\u0020\u0441\u0020\u0062\u0069\u0074\u0053\u0054\u004f\u004e\u0045"
} as const;

function PhoneIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path
        d="M7.2 4.8a1.7 1.7 0 0 1 2.1-.6l2.1.9c.7.3 1.1 1.1.9 1.8l-.5 2a1.5 1.5 0 0 0 .4 1.5l2.5 2.5a1.5 1.5 0 0 0 1.5.4l2-.5c.8-.2 1.5.2 1.8.9l.9 2.1a1.7 1.7 0 0 1-.6 2.1l-1.4 1a3 3 0 0 1-2.9.3c-2.2-.8-4.4-2.4-6.7-4.7-2.3-2.3-3.9-4.5-4.7-6.7a3 3 0 0 1 .3-2.9l1-1.4Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export function MobilePhoneButton({ phones }: { phones: SitePhone[] }) {
  const [isOpen, setIsOpen] = useState(false);
  const shellRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handlePointerDown(event: MouseEvent) {
      if (!shellRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    function handleEscape(event: KeyboardEvent) {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    }

    window.addEventListener("mousedown", handlePointerDown);
    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("mousedown", handlePointerDown);
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  if (!phones.length) {
    return null;
  }

  return (
    <div className={`mobile-phone-shell ${isOpen ? "mobile-phone-shell--open" : ""}`} ref={shellRef}>
      <button
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        aria-label={TEXT.showPhones}
        className="mobile-phone-trigger"
        onClick={() => setIsOpen((current) => !current)}
        type="button"
      >
        <PhoneIcon />
      </button>

      {isOpen ? (
        <div aria-label={TEXT.dialogTitle} className="mobile-phone-popover" role="dialog">
          <div className="mobile-phone-popover-title">{TEXT.contactTitle}</div>
          <div className="mobile-phone-popover-list">
            {phones.map((phone) => (
              <a className="mobile-phone-item" href={phone.href} key={`${phone.label}-${phone.display}`}>
                <span>{phone.label}</span>
                <strong>{phone.display}</strong>
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
